import { render, staticRenderFns } from "./SelectedCourse.vue?vue&type=template&id=2f7b394d&scoped=true&"
import script from "./SelectedCourse.vue?vue&type=script&lang=ts&"
export * from "./SelectedCourse.vue?vue&type=script&lang=ts&"
import style0 from "./SelectedCourse.vue?vue&type=style&index=0&id=2f7b394d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7b394d",
  null
  
)

export default component.exports